import { createContext } from 'use-context-selector';
import { ConsolidatedTransactionDetailsProviderState } from './types';
import { defaultConsolidatedTransactionDetailsProviderState } from './defaultState';

const ConsolidatedTransactionDetailsContext = createContext<ConsolidatedTransactionDetailsProviderState>(
  defaultConsolidatedTransactionDetailsProviderState,
);

export { ConsolidatedTransactionDetailsContext };
